export const ACADEMY = {
  name: "אקדמיית כדורסל הפועל מטה יהודה",
  shortName: "הפועל מטה יהודה",
  tagline: "בונים את הדור הבא של הכדורסל הישראלי",
  manager: "מעיין טנא",
  managerRole: "מנהל האקדמיה ומאמן ראשי",
  managerPhone: "050-7210131",
  managerWhatsapp: "972507210131",
  managerEmail: "Maayantene@gmail.com",
  leadProfessional: "יורם מנחם",
  leadProfessionalRole: "ליווי מקצועי צמוד",
  mentalCoach: "קובי רונדל",
  mentalCoachRole: "מאמן מנטלי",
  athleticCoach: "מאמן יכולות גופניות",
  athleticCoachRole: "אתלטיקה וחדר כושר",
  location: "בית הספר החקלאי עין כרם",
  audience: "בנים ובנות מגיל 14 ומעלה",
  openDayForm: "https://forms.gle/fCzaSNe9MYUXGGpR8",
  openDayDate: "יום שישי, 15.5",
  openDayTime: "09:00",
  instagram: "https://www.instagram.com/hapoelmateyehuda/",
  facebook: "https://www.facebook.com/HapoelMateYehuda",
  logo: "https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/zp18u9ps_%D7%9C%D7%95%D7%92%D7%95%20%D7%9E%D7%98%D7%94%20%D7%99%D7%94%D7%95%D7%93%D7%94%20%D7%9E%D7%A2%D7%95%D7%93%D7%9B%D7%9F%20%2816%29.jpg",
};

export const NAV_LINKS = [
  { to: "/", label: "בית" },
  { to: "/about", label: "אודות" },
  { to: "/program", label: "התכנית" },
  { to: "/coaches", label: "צוות מקצועי" },
  { to: "/schedule", label: "לו״ז שבועי" },
  { to: "/morning-academy-nachshon", label: "אקדמיית בוקר נחשון" },
  { to: "/morning-academy-ein-karem", label: "אקדמיית בוקר עין כרם" },
  { to: "/contact", label: "צור קשר" },
];

export const PILLARS = [
  {
    title: "הצד הטכני",
    icon: "Target",
    description:
      "2-3 אימוני יכולת אישית בשבוע בדגש על עמדת השחקן, בהנחיית מאמני האקדמיה. השחקנים יתאמנו גם אחר הצהריים בקבוצות הליגה של הפועל מטה יהודה.",
    points: [
      "אימוני יכולות אישיות (Skill Development)",
      "אימוני קליעה ייעודיים",
      "צילום וניתוח אימונים ומשחקים",
    ],
  },
  {
    title: "הצד הפיזי",
    icon: "Dumbbell",
    description:
      "תכנית רב-שנתית לפיתוח יכולות גופניות. שני אימוני יכולת גופנית בשבוע ואימון אחד בחדר כושר, בליווי מאמן אתלטיקה וצוות מקצועי.",
    points: [
      "מהירות, זריזות וכוח מתפרץ",
      "כוח פונקציונאלי וגמישות",
      "תכניות מותאמות אישית למניעת פציעות",
    ],
  },
  {
    title: "הצד המנטלי",
    icon: "Brain",
    description:
      "ליווי מנטלי צמוד מטעם המועדון. סדנאות ושיחות שבועיות, ליווי פרטני, וטיפוח כישורים חברתיים על ידי מדריכים ייעודיים.",
    points: [
      "סדנאות שבועיות בקבוצה",
      "ליווי מנטלי פרטני",
      "פסיכולוג ספורט ומדריך חברתי",
    ],
  },
];

export const COACHES = [
  {
    name: "מעיין טנא",
    role: "מנהל האקדמיה ומאמן ראשי",
    badge: "מנהל האקדמיה",
    description:
      "מנהל מקצועי בהפועל מטה יהודה, עוזר מאמן מכבי אשדוד בליגת העל גברים, בעל ניסיון רב באימון קבוצות נוער, נערים וילדים. מוביל את האקדמיה ומלווה את הספורטאים יום-יום.",
    image:
      "https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/5bt33mqv_untitled-213.jpg",
  },
  {
    name: "ענבר אוריון",
    role: "ניהול מקצועי וליווי הספורטאיות",
    badge: "אקדמיית בנות",
    description:
      "אחראית על הניהול המקצועי וליווי הספורטאיות באקדמיית הבנות. מביאה ניסיון עשיר מכדורסל הבוגרות ועמדת מודל לחיקוי לשחקניות הצעירות בדרכן לרמות הגבוהות.",
    image:
      "https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/izrlmn0a_6a0b3613-31e9-4eba-aa73-ec7ebb8dd76d%20-%20Edited.png",
  },
  {
    name: "יורם מנחם",
    role: "ליווי מקצועי צמוד",
    badge: "ליווי מקצועי",
    description:
      "מלווה את האקדמיה באופן צמוד, מביא איתו ניסיון עשיר וראייה מקצועית מקיפה לפיתוח שחקנים ושחקניות צעירים.",
    image:
      "https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/30ijgxpc_%D7%99%D7%95%D7%A8%D7%9D%20%D7%9E%D7%A0%D7%97%D7%9D.webp",
  },
  {
    name: "קובי רונדל",
    role: "מאמן מנטלי",
    badge: "מאמן מנטלי",
    description:
      "מרצה ויועץ בתחום הספורט וההעצמה האישית, מאמן אישי וקבוצתי. אחראי על הליווי המנטלי של השחקנים והשחקניות באקדמיה.",
    image:
      "https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/2ay980qe_%D7%A7%D7%95%D7%91%D7%99%20%D7%A8%D7%95%D7%A0%D7%93%D7%9C%20%D7%AA%D7%9E%D7%95%D7%A0%D7%94.jpeg",
  },
];

export const WEEKLY_SCHEDULE = [
  { day: "ראשון", morning: "—", evening: "אימון קבוצה 1" },
  { day: "שני", morning: "אימון כוח (1)", evening: "אימון קבוצה 2" },
  { day: "שלישי", morning: "אימון כדורסל (1)", evening: "אימון קבוצה 3" },
  { day: "רביעי", morning: "—", evening: "אימון כוח (2) + אימון קבוצה 4" },
  { day: "חמישי", morning: "אימון כדורסל (2)", evening: "אימון קבוצה 5" },
  { day: "שישי", morning: "מנוחה אקטיבית / קליעות קלות", evening: "זמן חופשי / הכנה למשחק" },
  { day: "שבת", morning: "מנוחה מלאה", evening: "מנוחה" },
];

export const SCHEDULE_HIGHLIGHTS = [
  {
    title: "3 אימוני בוקר",
    description: "שני אימוני כדורסל ואימון כוח אחד, מתחילים את היום בעוצמה.",
  },
  {
    title: "5 אימוני קבוצה",
    description: "אימונים בקבוצות הליגה של הפועל מטה יהודה לאורך כל השבוע.",
  },
  {
    title: "Double Session",
    description: "יום עמוס ברביעי — אימון כוח לפני אימון הקבוצה, כשחקן מקצועני.",
  },
  {
    title: "התאוששות",
    description: "סוף שבוע מלא להתאוששות הגוף ולהכנה למשחקים.",
  },
];
